export const countriesSolarData = [
    {
        eu_countries: "Austria",
        emission_factor_electirity: 0.147226193,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "69%",
        information: "Switching to solar energy reduces your carbon footprint by 69%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/AT/all/yearly"
    },
    {
        eu_countries: "Belgium",
        emission_factor_electirity: 0.1388178,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "68%",
        information: "Switching to solar energy reduces your carbon footprint by 68%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/BE/all/yearly"
    },
    {
        eu_countries: "Bulgaria",
        emission_factor_electirity: 0.553712128,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "92%",
        information: "Switching to solar energy reduces your carbon footprint by 92%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/BG/all/yearly"
    },
    {
        eu_countries: "Croatia",
        emission_factor_electirity: 0.254694925,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "82%",
        information: "Switching to solar energy reduces your carbon footprint by 82%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/HR/all/yearly"
    },
    {
        eu_countries: "Cyprus",
        emission_factor_electirity: 0.654931502,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "93%",
        information: "Switching to solar energy reduces your carbon footprint by 93%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/CY/all/yearly"
    },
    {
        eu_countries: "Czech Republic",
        emission_factor_electirity: 0.764131772,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "94%",
        information: "Switching to solar energy reduces your carbon footprint by 94%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/CZ/all/yearly"
    },
    {
        eu_countries: "Denmark",
        emission_factor_electirity: 0.187308499,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "76%",
        information: "Switching to solar energy reduces your carbon footprint by 76%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/DK/all/yearly"
    },
    {
        eu_countries: "Estonia",
        emission_factor_electirity: 0.7535286,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "94%",
        information: "Switching to solar energy reduces your carbon footprint by 94%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/EE/all/yearly"
    },
    {
        eu_countries: "Finland",
        emission_factor_electirity: 0.095304975,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "53%",
        information: "Switching to solar energy reduces your carbon footprint by 53%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/FI/all/yearly"
    },
    {
        eu_countries: "France",
        emission_factor_electirity: 0.062067421,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "27%",
        information: "Switching to solar energy reduces your carbon footprint by 28%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/FR/all/yearly"
    },
    {
        eu_countries: "Germany",
        emission_factor_electirity: 0.449116937,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "90%",
        information: "Switching to solar energy reduces your carbon footprint by 90%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/DE/all/yearly"
    },
    {
        eu_countries: "Greece",
        emission_factor_electirity: 0.378402717,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "88%",
        information: "Switching to solar energy reduces your carbon footprint by 88%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/GR/all/yearly"
    },
    {
        eu_countries: "Hungary",
        emission_factor_electirity: 0.270373945,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "83%",
        information: "Switching to solar energy reduces your carbon footprint by 83%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/HU/all/yearly"
    },
    {
        eu_countries: "Iceland",
        emission_factor_electirity: 0.000173793,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "NA",
        information: "No significant reduction, as your country's electricity source mix is already very low in carbon emissions."
    },
    {
        eu_countries: "Italy",
        emission_factor_electirity: 0.36424782,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "88%",
        information: "Switching to solar energy reduces your carbon footprint by 88%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/IT/all/yearly"
    },
    {
        eu_countries: "Latvia",
        emission_factor_electirity: 0.1480746,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "70%",
        information: "Switching to solar energy reduces your carbon footprint by 70%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/LV/all/yearly"
    },
    {
        eu_countries: "Lithuania",
        emission_factor_electirity: 0.2711034,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "83%",
        information: "Switching to solar energy reduces your carbon footprint by 83%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/LT/all/yearly"
    },
    {
        eu_countries: "Luxembourg",
        emission_factor_electirity: 0.084927989,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "47%",
        information: "Switching to solar energy reduces your carbon footprint by 47%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/LU/all/yearly"
    },
    {
        eu_countries: "Malta",
        emission_factor_electirity: 0.426888067,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "89%",
        information: "Switching to solar energy reduces your carbon footprint by 89%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/MT/all/yearly"
    },
    {
        eu_countries: "Netherlands",
        emission_factor_electirity: 0.340889274,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "87%",
        information: "Switching to solar energy reduces your carbon footprint by 87%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/NL/all/yearly"
    },
    {
        eu_countries: "Poland",
        emission_factor_electirity: 0.877610388,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "95%",
        information: "Switching to solar energy reduces your carbon footprint by 95%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/PL/all/yearly"
    },
    {
        eu_countries: "Portugal",
        emission_factor_electirity: 0.156408,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "71%",
        information: "Switching to solar energy reduces your carbon footprint by 71%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/PT/all/yearly"
    },
    {
        eu_countries: "Romania",
        emission_factor_electirity: 0.311475295,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "86%",
        information: "Switching to solar energy reduces your carbon footprint by 86%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/RO/all/yearly"
    },
    {
        eu_countries: "Slovakia",
        emission_factor_electirity: 0.176223865,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "74%",
        information: "Switching to solar energy reduces your carbon footprint by 74%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/SK/all/yearly"
    },
    {
        eu_countries: "Slovenia",
        emission_factor_electirity: 0.273292451,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "84%",
        information: "Switching to solar energy reduces your carbon footprint by 84%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/SI/all/yearly"
    },
    {
        eu_countries: "Spain",
        emission_factor_electirity: 0.177088415,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "75%",
        information: "Switching to solar energy reduces your carbon footprint by 75%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/ES/all/yearly"
    },
    {
        eu_countries: "Sweden",
        emission_factor_electirity: 0.00730516,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "NA",
        information: "No significant reduction, as your country's electricity source mix is already very low in carbon emissions."
    },
    {
        eu_countries: "United Kingdom",
        emission_factor_electirity: 0.2249894,
        emission_factor_solar_hotovoltaics: 0.045,
        reduction: "80%",
        information: "Switching to solar energy reduces your carbon footprint by 80%. This is because your country's electricity grid emits more CO2 than solar power. See the source mix of your country here: https://app.electricitymaps.com/zone/GB/all/yearly"
    }
]